import { tour } from 'aria-viewer/utils/functions'
import bugsnagClient from '../../core/bugsnagClient'

/**
 * Returns tour data based on the given state.
 */
export const getTourData = () => getState => {
    const state = getState()

    // Tour
    const { type } = tour(state)
    const tourid = state.getIn(['tour', 'tours', 'current'])

    // Location
    const locations = state.getIn(['tour', 'locations', 'list'])
    const locIndex = state.getIn(['tour', 'locations', 'current'])
    const { name: loc_name, loc_id, inst_name, owner_id } = locations[locIndex]

    // Stop
    const stopIndex = state.getIn(['tour', 'stops', 'current']) || 0
    const stops = state.getIn(['tour', 'stops', 'list'])

    const stopVisitedCount = state.getIn(['tour', 'stops', 'visitedCount'])
    const totalStops = stops.size
    const { title: stoptitle, stopid } = stops.get(stopIndex) || {}

    // Analytics
    const userkey = state.getIn(['analytics', 'userkey'])
    const sessionId = state.getIn(['analytics', 'sessionId'])

    // Registration
    const welcomePrompt = state.getIn(['tour', 'registration', 'welcomePrompt'])

    // isClient
    const isClient = state.getIn(['tour', 'isClient'])
    const clientProperties = state.getIn(['tour', 'client'])
    const isClientApp = clientProperties.isClientApp || false

    // Actions
    const actions = state.getIn(['tour', 'actionButtons', 'actions'])

    // Payments
    const itemTitle = state.getIn(['payments', 'selectedItemDetails', 'title'])
    const itemID = state.getIn(['payments', 'selectedItemDetails', 'payments_product_id'])
    const paymentPageName = state.getIn(['payments', 'paymentPageName'])
    const paymentShippingAddress = state.getIn(['payments', 'shippingAddress'])

    // Device
    const appVersion = state.getIn(['device', 'appVersion'])
    const grade = state.getIn(['device', 'grade'])
    const gpu = state.getIn(['device', 'gpu'])
    const deviceType = state.getIn(['device', 'deviceType'])
    const optimalVersion = state.getIn(['device', 'optimalVersion'])
    const deviceGrade = state.getIn(['device', 'deviceGrade'])
    const webVR = state.getIn(['device', 'webVR'])
    const browser = state.getIn(['device', 'browser'])

    // Stats
    const meanFPS = state.getIn(['stats', 'calculatedFPS', 'mean'])
    const minFPS = state.getIn(['stats', 'calculatedFPS', 'min'])
    const maxFPS = state.getIn(['stats', 'calculatedFPS', 'max'])
    const oneMinMeanFPS = state.getIn(['stats', 'calculatedFPS', '1_min_mean'])
    const fiveMinMeanFPS = state.getIn(['stats', 'calculatedFPS', '5_min_mean'])

    const platform = state.getIn(['tour', 'platform'])

    return {
        loc_name,
        loc_id,
        inst_name,
        owner_id,
        stoptitle,
        stopIndex,
        stopid,
        totalStops,
        stopVisitedCount,
        userkey,
        sessionId,
        welcomePrompt,
        type,
        tourid,
        isClient,
        actions,
        clientProperties,
        isClientApp,
        platform,
        itemTitle,
        itemID,
        paymentPageName,
        paymentShippingAddress,
        appVersion,
        grade,
        gpu,
        deviceType,
        optimalVersion,
        deviceGrade,
        webVR,
        browser,
        meanFPS,
        minFPS,
        maxFPS,
        oneMinMeanFPS,
        fiveMinMeanFPS,
    }
}

/**
 * Get mobile default properties for event tracking
 * @return properties for given state
 */
export const getMobileDefaultProperties = () => getState => {
    const { loc_name, loc_id, inst_name, owner_id, userkey, isClientApp } = getTourData()(getState)
    return {
        Institution: inst_name,
        Location: loc_name,
        Inst_ID: owner_id,
        Loc_ID: loc_id,
        Userkey: userkey,
        isClientApp,
    }
}

export const _btoa = data => {
    try {
        return btoa(data)
    } catch (error) {
        bugsnagClient.notify(error)
        return data
    }
}
